/* eslint-disable no-return-assign */
/* eslint-disable spaced-comment */
/* eslint-disable max-classes-per-file */
/* eslint-disable no-var */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable dot-notation */
import {
  IEntity,
  LiteralObject,
  ViggoCoreColumnDef
} from 'viggo-sistemas-core-web';
import {
  COLUNAS_DEFAULT_PROJETO,
  COLUNAS_DEFAULT_SYSDAMIN
} from './colunas/colunas_default';

interface T extends IEntity {}

export interface IColunasSettingsUser {
  module: string;
  colunas: ViggoCoreColumnDef<T>[];
}

export class ValidadorSettingsUser {
  //COLUNAS
  colunas = [] as IColunasSettingsUser[];

  constructor(public user_settings: LiteralObject, public isSysadmin: boolean) {
    const user_regras = user_settings['regras'] ?? {};
    const user_colunas = user_settings['colunas'] ?? [];
    //COLUNAS
    this.colunas = this.getColunasMenu(
      user_colunas.filter(it => it !== null && it !== undefined),
      isSysadmin
    );
  }

  getColunasMenu(user_colunas: IColunasSettingsUser[], isSysadmin: boolean) {
    const defaultColumns = !isSysadmin
      ? COLUNAS_DEFAULT_PROJETO
      : COLUNAS_DEFAULT_SYSDAMIN;
    var result = [];
    var colunas = user_colunas ?? [];
    if (colunas.length !== 0) {
      defaultColumns.forEach((col: IColunasSettingsUser) => {
        const index = colunas.findIndex(it => col.module === it.module);
        if (index >= 0) {
          result.push(colunas[index]);
        } else {
          result.push(col);
        }
      });
    } else {
      result = defaultColumns;
    }
    return result;
  }

  getUserSettingsBody(user_settings) {
    return (user_settings = {
      regras: {},
      colunas: this.colunas
    });
  }
}
